export const marimoApp = `"""An autogenerated example Marimo app."""

import marimo

__generated_with = "0.9.20"
app = marimo.App(width="medium")


@app.cell
def __():
    import marimo as mo
    return (mo,)


@app.cell
def __(mo):
    mo.md(
        r"""
        # Hello World!
        ## I am a Marimo app, deployed with Numerous
        """
    )
    return


if __name__ == "__main__":
    app.run()
` as const;
